module.exports = __webpack_public_path__ + "img/seal-alpha-ssl.72dd1206.svg";